/*
 * 某天按周几走（节假日按周五/周六的营业时间和每周特殊价格），cloud #437
 */
import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { reservationLocalHost } from '@/model/dataLayer/api/newReservation/reservation'

const url = reservationLocalHost + '/settings/dateAsWeekday/'

/** 后端没有这个接口时返回 null（页面就不显示这一块） */
export async function getDateAsWeekdayList () {
  const res = await hillo.silentGet(url + await getCurrentDeviceId(), {})
  if (res?.code === 200 && Array.isArray(res.data)) {
    return res.data
  }
  return null
}

/** item: { id?, date: 'yyyy-MM-dd', asDayOfWeek: 1–7, note? }；同一天已有就覆盖 */
export async function saveDateAsWeekday (item) {
  return (await hillo.jsonPost(url + 'save', {
    ...item,
    deviceId: await getCurrentDeviceId()
  }))
}

export async function deleteDateAsWeekday (id) {
  return (await hillo.post(`${url}${id}/delete`, {}))
}
